module.exports = __webpack_public_path__ + "static/author-kzv-img-b4c3db7ebd2fd3be4c2a5487b5b39ac3.png";